// useTranslationState.js - Translation functionality state management
import { useState } from 'react';
import { DEFAULT_TRANSLATION_MODEL } from '../constants/translationConfig';

export const useTranslationState = () => {
  // Translation configuration
  const [targetLanguage, setTargetLanguage] = useState('en-US');
  const [translationModel, setTranslationModel] = useState(DEFAULT_TRANSLATION_MODEL);

  // Translation process state
  const [isTranslatingAll, setIsTranslatingAll] = useState(false);
  const [translatingFields, setTranslatingFields] = useState({});
  const [translationProgress, setTranslationProgress] = useState([]);

  // Translation utility functions
  const resetTranslationState = () => {
    setIsTranslatingAll(false);
    setTranslatingFields({});
    setTranslationProgress([]);
  };

  const updateTranslatingFields = (fieldUpdates) => {
    setTranslatingFields(prev => ({
      ...prev,
      ...fieldUpdates
    }));
  };

  const addTranslationProgress = (progressItem) => {
    setTranslationProgress(prev => [...prev, progressItem]);
  };

  const updateTranslationProgress = (index, updates) => {
    setTranslationProgress(prev =>
      prev.map((item, i) => i === index ? { ...item, ...updates } : item)
    );
  };

  const clearTranslationProgress = () => {
    setTranslationProgress([]);
  };

  const startFieldTranslation = (fieldKey) => {
    setTranslatingFields(prev => ({
      ...prev,
      [fieldKey]: true
    }));
  };

  const endFieldTranslation = (fieldKey) => {
    setTranslatingFields(prev => {
      const updated = { ...prev };
      delete updated[fieldKey];
      return updated;
    });
  };

  return {
    // Translation config
    targetLanguage,
    setTargetLanguage,
    translationModel,
    setTranslationModel,

    // Translation process state
    isTranslatingAll,
    setIsTranslatingAll,
    translatingFields,
    setTranslatingFields,
    translationProgress,
    setTranslationProgress,

    // Utility functions
    resetTranslationState,
    updateTranslatingFields,
    addTranslationProgress,
    updateTranslationProgress,
    clearTranslationProgress,
    startFieldTranslation,
    endFieldTranslation
  };
};
